import CountrySettings from './CountrySettings';

export default CountrySettings;
